import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";

import WidgetWrapper from "./WidgetWrapper";
import Mission from "../Mission";

export default class WidgetMissions extends Component {
  render() {
    const data = this.props.detailData;

    const hasData =
      data &&
      ((Array.isArray(data.folderCompany) && data.folderCompany.length) ||
        (Array.isArray(data.mission) && data.mission.length));

    return (
      <WidgetWrapper
        title="Répartition compagnie"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {!data ? (
          <Loader />
        ) : hasData ? (
          <Mission data={data} perimeter={this.props.perimeter} />
        ) : (
          <p className="mt-10 mb-10" style={{ textAlign: "center", color: "#999" }}>
            Aucune donnée disponible
          </p>
        )}
      </WidgetWrapper>
    );
  }
}
